// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/chart.type';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const reactionsHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.facebook.reactions_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.facebook.reactions_history_name',
        avg: 'chart.facebook.reactions_history_avg'
    },
    id: 'reactions_history',
    color: {
        value: 'red'
    },
    noLegend: true,
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    isXAxisDate: true,
    type: 'chart',
    element: LineChart
};
